import { t } from "@lingui/macro"
import { IterationType, SurveyResponse, SurveyStatus } from "@src/api/survey"
import {
  addDays,
  addWeeks,
  addMonths,
  addQuarters,
  addYears,
} from "date-fns"

export const getSurveyIterationType = (iterationType?: IterationType) => {
  switch (iterationType) {
    case IterationType.Weekly:
      return t`Week`
    case IterationType.Monthly:
      return t`Month`
    case IterationType.Quarterly:
      return t`Quarter`
    case IterationType.Semestral:
      return t`Semester`
    case IterationType.Yearly:
      return t`Year`
    default:
      return t`Iteration`
  }
}

export const getIterationText = (
  iteration?: number | null,
  iterationType?: IterationType,
) => {
  if (iterationType === IterationType.NonRecurrent) {
    return "N/A"
  }

  if (iteration === null || iteration === undefined) {
    return ""
  }

  return iteration
}

export const getSubmissionDateText = (
  surveyResponse: SurveyResponse,
  locale?: string,
) => {
  const isSubmitted = surveyResponse.status === SurveyStatus.Submitted

  if (!isSubmitted || !surveyResponse.answers?.length) {
    return "-"
  }

  const latestSubmissionDate = surveyResponse.answers
    .map((answer) => answer.lastSubmitedTime)
    .filter((dateTime) => dateTime !== null && dateTime !== undefined)
    .reduce((latest, current) => {
      return new Date(current) > new Date(latest) ? current : latest
    }, surveyResponse.answers[0]?.lastSubmitedTime as string)

  return latestSubmissionDate
    ? new Intl.DateTimeFormat(locale, { dateStyle: "medium" }).format(
        new Date(latestSubmissionDate),
      )
    : "-"
}

export const getNextIterationDeadline = (
  prevIterationDeadline?: string | null,
  iterationType?: IterationType,
  iterationDuration?: number,
) => {
  const prevDate = new Date(prevIterationDeadline || Date.now())

  switch (iterationType) {
    case IterationType.Weekly:
      return addWeeks(prevDate, 1)
    case IterationType.Monthly:
      return addMonths(prevDate, 1)
    case IterationType.Quarterly:
      return addQuarters(prevDate, 1)
    case IterationType.Semestral:
      return addMonths(prevDate, 6)
    case IterationType.Yearly:
      return addYears(prevDate, 1)
    case IterationType.Custom:
      return addDays(prevDate, iterationDuration || 1)
    default:
      return prevDate
  }
}
